import { useState } from "react";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { SERVER_URL } from "./util";

export const DeleteAccountPage = () => {
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const token = searchParams.get("token");

	const [isLoading, setIsLoading] = useState(false);
	const [formError, setFormError] = useState(null);
	const [hasBeenDeleted, setHasBeenDeleted] = useState(false);

	const handleConfirm = async (e) => {
		e.preventDefault();
		if (isLoading || !token) return;
		setIsLoading(true);
		setFormError(null);
		try {
			const res = await fetch(SERVER_URL + "/user/delete-account", {
				method: "POST",
				credentials: "include",
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ token }),
			});
			setIsLoading(false);
			if (res.ok) {
				Cookies.remove("ordel_user");
				setHasBeenDeleted(true);
			} else {
				setFormError("Länken är ogiltig eller har gått ut.");
			}
		} catch (e) {
			setIsLoading(false);
			setFormError("Något gick fel. Försök igen senare.");
		}
	};

	if (!token) {
		return (
			<div
				className="account-wrapper"
				style={{
					maxWidth: "500px",
					margin: "0 auto",
					color: "#fff",
				}}
			>
				<h2>Radera konto</h2>
				<p>Ogiltig eller saknad länk.</p>
			</div>
		);
	}

	if (hasBeenDeleted) {
		return (
			<div
				className="account-wrapper"
				style={{
					maxWidth: "500px",
					margin: "0 auto",
					color: "#fff",
				}}
			>
				<h2>Radera konto</h2>
				<p>Ditt konto har raderats. Du kan nu stänga detta fönster</p>
			</div>
		);
	}

	return (
		<div
			className="account-wrapper"
			style={{
				maxWidth: "500px",
				margin: "0 auto",
				color: "#fff",
			}}
		>
			<h2>Radera konto</h2>
			<p>
				All din statistik och spelhistorik raderas permanent. Detta kan inte
				ångras. Är du helt säker på att du vill radera ditt konto?
			</p>
			<form onSubmit={handleConfirm}>
				<button type="submit" className="primary margin" disabled={isLoading}>
					{isLoading ? "Laddar..." : "Bekräfta radering"}
				</button>
				{formError && <div className="formerror">{formError}</div>}
			</form>
		</div>
	);
};
